var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompassAiModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.75 30.75C36.4109 25.0891 36.4109 15.9109 30.75 10.25C25.0891 4.58909 15.9109 4.58908 10.25 10.25C4.58908 15.9109 4.58908 25.0891 10.25 30.75C15.9109 36.4109 25.0891 36.4109 30.75 30.75Z",
    fill: "#F8F9FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9998 31.0231C26.5344 31.0231 31.0211 26.5364 31.0211 21.0018C31.0211 15.4672 26.5344 10.9805 20.9998 10.9805C15.4652 10.9805 10.9785 15.4672 10.9785 21.0018C10.9785 26.5364 15.4652 31.0231 20.9998 31.0231Z",
    fill: "#7C8687"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5863 27.5861C31.4998 23.6725 31.4998 17.3275 27.5863 13.4139C23.6728 9.50042 17.3277 9.50042 13.4142 13.4139C9.50066 17.3275 9.50066 23.6725 13.4142 27.5861C17.3277 31.4996 23.6728 31.4996 27.5863 27.5861Z",
    fill: "#ECEFEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5651 12.4375L20.499 18.2936L21.604 19.3986L28.5651 12.4375Z",
    fill: "#11431E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3185 21.6831L18.2135 20.5781L12.4385 28.5631L19.3185 21.6831Z",
    fill: "#11431E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5637 12.4375L22.7075 20.5036L21.6025 19.3986L28.5637 12.4375Z",
    fill: "#11431E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3165 21.6836L20.4215 22.7888L12.4365 28.5636L19.3165 21.6836Z",
    fill: "#11431E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5637 28.5622L22.7075 20.4961L21.6025 21.6011L28.5637 28.5622Z",
    fill: "#11431E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3165 19.3177L20.4215 18.2125L12.4365 12.4375L19.3165 19.3177Z",
    fill: "#11431E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5651 28.5624L20.499 22.7065L21.604 21.6016L28.5651 28.5624Z",
    fill: "#11431E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3185 19.3175L18.2135 20.4225L12.4385 12.4375L19.3185 19.3175Z",
    fill: "#11431E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3443 20.4988L22.6537 17.4141L20.4971 20.4988H32.3443Z",
    fill: "#20E290"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3443 20.4961L22.6537 23.5808L20.4971 20.4961H32.3443Z",
    fill: "#9CFFD5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65918 20.5L18.3498 23.5847L20.5064 20.5H8.65918Z",
    fill: "#20E290"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65918 20.5066L18.3498 17.4219L20.5064 20.5066H8.65918Z",
    fill: "#9CFFD5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5037 8.66016L17.4189 17.7154L20.5037 20.5074V8.66016Z",
    fill: "#20E290"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M20.499 8.66016L23.5838 17.7154L20.499 20.5074V8.66016Z",
    fill: "#9CFFD5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.499 32.3394L23.5838 23.2472L20.499 20.4922V32.3394Z",
    fill: "#20E290"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5037 32.3394L17.4189 23.2472L20.5037 20.4922V32.3394Z",
    fill: "#9CFFD5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8672 8.26384V6.73438H20.2711L20.5884 7.29481C20.6794 7.45582 20.7702 7.6466 20.8382 7.81902H20.8449C20.8223 7.61708 20.8154 7.41042 20.8154 7.18143V6.73438H21.1332V8.26384H20.7702L20.4432 7.67389C20.3527 7.5104 20.2525 7.31317 20.1778 7.1338L20.1708 7.13603C20.18 7.33798 20.1845 7.55356 20.1845 7.80314V8.26384H19.8672Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0465 33.7527C20.1396 33.8003 20.2827 33.848 20.4301 33.848C20.5891 33.848 20.6729 33.7822 20.6729 33.6822C20.6729 33.5872 20.6005 33.5324 20.4164 33.4667C20.1621 33.3783 19.9967 33.2374 19.9967 33.0151C19.9967 32.7541 20.2147 32.5547 20.5754 32.5547C20.7481 32.5547 20.8751 32.5909 20.9657 32.6318L20.8885 32.9109C20.8275 32.8814 20.7186 32.838 20.569 32.838C20.4189 32.838 20.3465 32.9062 20.3465 32.9856C20.3465 33.0831 20.4326 33.1263 20.63 33.2012C20.9002 33.3009 21.0272 33.4419 21.0272 33.6572C21.0272 33.9137 20.8297 34.1315 20.41 34.1315C20.2351 34.1315 20.0626 34.0861 19.9766 34.0385L20.0465 33.7527Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99772 21.1782L6.63477 19.6487H7.00467L7.12028 20.2796C7.15451 20.4612 7.18627 20.6587 7.21108 20.8127H7.21553C7.24059 20.6472 7.27682 20.4634 7.31552 20.2751L7.44477 19.6487H7.8122L7.93475 20.2932C7.96898 20.4723 7.99379 20.6358 8.01661 20.806H8.02108C8.04391 20.6358 8.07789 20.4565 8.10965 20.2749L8.23444 19.6484H8.58623L8.19127 21.1779H7.8169L7.68765 20.5197C7.65813 20.3654 7.63307 20.2225 7.61496 20.0479H7.61024C7.5832 20.2203 7.55815 20.3657 7.52168 20.5197L7.37655 21.1779H6.99772V21.1782Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7447 20.5311H33.182V20.8943H33.8104V21.1779H32.835V19.6484H33.7789V19.932H33.182V20.2498H33.7447V20.5311Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompassAiModalIcon);
export default __webpack_public_path__ + "static/media/compass_ai_modal_icon.f553e015342880faffb99718aad28263.svg";
export { ForwardRef as ReactComponent };